import React from "react";
import "./Headings.scss";
export type size = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
export type defaultClass =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "h7"
  | "h8";
export type fontWeight = "bold" | "normal" | "semibold";
export interface Headingprops {
  size?: size;
  className?: any;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  id?: any;
  defaultClass?: string;
  fontWeight?: fontWeight;
  role?: string;
  ariaLabel?: string;
}
const Headings = ({
  size: Element = "h1",
  className,
  defaultClass = "h2",
  children,
  style,
  id,
  fontWeight,
  role,
  ariaLabel,
}: Headingprops) => {
  return (
    <Element
      className={`headings ${defaultClass}${className ? " " + className : ""}${
        fontWeight ? " " + fontWeight : ""
      }`}
      id={id}
      style={style}
      role={role}
      aria-label={ariaLabel}
    >
      {children}
    </Element>
  );
};

export default Headings;
